import { BaseQuestionAnswerComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { EssayAnswerEditorComponent } from '../../../../essay-answer-editor';
import { jsx as _jsx } from "react/jsx-runtime";
export var EssayAnswerComponent = function EssayAnswerComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var answer = states.answer,
      audioFile = states.audioFile,
      essayQuestionLabel = states.essayQuestionLabel,
      updateAnswerStatus = states.updateAnswerStatus,
      draftAnswer = states.draftAnswer,
      file = states.file,
      updateFileAnswerStatus = states.updateFileAnswerStatus,
      isHideComponent = states.isHideComponent,
      editorLabels = states.editorLabels,
      disabled = states.disabled;
  var handleUpdateEssayAnswer = actions.handleUpdateEssayAnswer,
      handleUpdateDraftEssayAnswer = actions.handleUpdateDraftEssayAnswer,
      handleDeleteDraftEssayAnswer = actions.handleDeleteDraftEssayAnswer,
      onShowingUploadFileModal = actions.onShowingUploadFileModal,
      _onShowingAudioUploadModal = actions.onShowingAudioUploadModal;
  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(EssayAnswerEditorComponent, {
      questionId: question.id,
      questionIndex: question.index,
      readOnlyStatus: disabled,
      draftAnswer: draftAnswer,
      answer: answer,
      onUpdateAnswer: handleUpdateEssayAnswer,
      onUpdateDraftAnswer: handleUpdateDraftEssayAnswer,
      onDeleteDraftAnswer: handleDeleteDraftEssayAnswer,
      onShowingUploadModal: function onShowingUploadModal() {
        return onShowingUploadFileModal();
      },
      onShowingAudioUploadModal: function onShowingAudioUploadModal() {
        return _onShowingAudioUploadModal(audioFile);
      },
      updateAnswerStatus: updateAnswerStatus,
      label: essayQuestionLabel,
      file: file,
      updateFileAnswerStatus: updateFileAnswerStatus,
      isHideComponent: isHideComponent,
      editorLabels: editorLabels,
      audioFile: audioFile,
      audioPlayerLabels: states.audioPlayerLabels
    })
  });
};